module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-11.f567dcbc.png";